/**
 * Code syntax highlighting hook
 *
 * NOTE: Syntax highlighting is now integrated in the MarkdownRenderer hook
 * (assets/js/hooks/markdown_renderer.js) with streaming awareness.
 * Highlighting only applies when streaming is complete to avoid performance issues.
 *
 * This hook remains for backward compatibility with any server-rendered code blocks
 * that aren't processed through the markdown renderer.
 */
import hljs from 'highlight.js';

const CodeHighlight = {
  mounted() {
    this.highlight();
  },

  updated() {
    this.highlight();
  },

  highlight() {
    // Only add styling classes - no DOM manipulation
    // This is safe because we're only adding classes to existing elements
    this.el.querySelectorAll('pre code').forEach((block) => {
      block.classList.add('language-code');

      // Apply syntax highlighting if not already highlighted
      if (!block.dataset.highlighted) {
        hljs.highlightElement(block);
        block.dataset.highlighted = 'true';
      }
    });

    // Ensure pre blocks have relative positioning for copy buttons
    this.el.querySelectorAll('pre').forEach((pre) => {
      pre.style.position = 'relative';
    });
  }
};

export default CodeHighlight;
